import { ListItem, ListItemButton, ListItemIcon, ListItemText, Box } from "@mui/material";
import React, { FC } from "react";
import { palette } from "../../theme";
import { useLocation, useNavigate } from "react-router-dom";

export interface SmallSidebarItemData {
  label: string,
  icon?: React.ReactNode,
  route: string,
};

interface SmallSidebarItemProps {
  expanded: boolean;
  route: string;
  icon?: React.ReactNode;
  label: string;
  onClose?: () => void;
}

const SmallSidebarItem: FC<SmallSidebarItemProps> = ({ onClose, route, expanded, icon, label }) => {
  const nav = useNavigate();
  const location = useLocation();
  const selected = location.pathname === route;

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={() => {
          if (route && !selected) {
            nav(route);
            onClose?.();
          }
        }}
        sx={{
          px: 3,
          py: 1.5,
          minHeight: 48,
          gap: 1.5,
          borderLeft: selected ? "2px solid #0E6FFF" : "2px solid transparent",
          bgcolor: selected ? "#0E6FFF0D" : "transparent",
          color: selected ? "#0E6FFF" : "#0B1620",
          "&:hover": {
            bgcolor: selected ? "#0E6FFF0D" : "#F5F7FA",
          },
          justifyContent: expanded ? "flex-start" : "center",
        }}
      >
        {icon && (
          <ListItemIcon
            sx={{
              minWidth: expanded ? "32px" : "auto",
              color: "inherit",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& svg": {
                width: "20px",
                height: "20px",
              },
            }}
          >
            {icon}
          </ListItemIcon>
        )}
        {expanded && (
          <Box
            component="span"
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </Box>
        )}
      </ListItemButton>
    </ListItem>
  );

}

export default SmallSidebarItem;